<template>
  <footer :class="$style.header">
    <div :class="$style.wrapper">
      © GO2 Partners ©{{ new Date().getFullYear() }}
    </div>
  </footer>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'LayoutFooter',
};
</script>
<style lang="scss"
       module>
@import '../brand/brandColors.variables.scss';

.header {
  background-color: $steel-gray;
  height: 5rem;
}

.wrapper {
  composes: pageContainer from '../brand/structure.scss';
  composes: standard from '../brand/typography.scss';
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: $white;
}
</style>
